import moment from "moment";

export default {
    filters: {
        formatDate: function(date) {
            return moment(date).format("DD MMMM YYYY");
        },
        formatDetailsLink: function(permalink) {
            const url = new URL(window.location.href);
            const lang = url.searchParams.get('lang');

            if (lang !== null) {
                return permalink + "?lang=" + lang;
            }

            return permalink;
        },
        formatPermalink: function(permalink) {
            const url = new URL(window.location.href);
            const queryString = url.searchParams.toString();

            if (queryString.length > 0) {
                return permalink + "?" + queryString;
            }

            return permalink;
        }
    }
}
